/**
 * Tulasyam Luxury Gift Packaging Feature
 * Modal Handler, Validation, WhatsApp/Lead API Dispatch & Multi-Item Cart Add
 */

(function () {
  'use strict';

  // Global functions accessible from inline HTML
  window.openGiftPackagingModal = function (sectionId) {
    const modal = document.getElementById('GiftPackagingModal-' + sectionId);
    if (!modal) return;

    // Teleport modal directly into body to avoid ancestor CSS stacking/clipping
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add('is-active');
    document.body.classList.add('overflow-hidden');

    // Focus on first input
    const firstInput = modal.querySelector('#GiftInputTo-' + sectionId);
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 200);
    }
  };

  window.closeGiftPackagingModal = function (sectionId) {
    const modal = document.getElementById('GiftPackagingModal-' + sectionId);
    if (!modal) return;

    modal.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
  };

  window.handleGiftPhoneInput = function (input, sectionId) {
    if (!input) return;
    let val = input.value.replace(/\D/g, '');
    const hintEl = document.getElementById('GiftPhoneHint-' + sectionId);

    // Auto-strip country prefix if pasted (e.g. 919876543210 or 09876543210)
    if (val.length > 10 && val.indexOf('91') === 0) {
      val = val.substring(2);
    } else if (val.length > 10 && val.indexOf('0') === 0) {
      val = val.substring(1);
    }

    if (val.length > 0 && !/^[6-9]/.test(val)) {
      if (hintEl) {
        hintEl.textContent = 'Mobile number must start with 6, 7, 8, or 9';
        hintEl.style.display = 'block';
      }
      val = val.replace(/^[^6-9]+/, '');
    } else if (hintEl) {
      if (val.length > 0 && val.length < 10) {
        hintEl.textContent = `Please enter 10 digits (${val.length}/10 entered)`;
        hintEl.style.display = 'block';
      } else {
        hintEl.textContent = '';
        hintEl.style.display = 'none';
      }
    }

    if (val.length > 10) {
      val = val.substring(0, 10);
    }

    input.value = val;

    if (val.length === 0) {
      input.setCustomValidity('Please enter your 10-digit mobile number');
    } else if (!/^[6-9]/.test(val)) {
      input.setCustomValidity('Indian mobile numbers must start with 6, 7, 8, or 9');
    } else if (val.length < 10) {
      input.setCustomValidity(`Please enter complete 10-digit mobile number (${val.length}/10 digits)`);
    } else {
      input.setCustomValidity('');
      if (hintEl) {
        hintEl.textContent = '';
        hintEl.style.display = 'none';
      }
    }
  };

  // Attach dynamic functions per section
  function initSectionHelpers(modal) {
    const sectionId = modal.dataset.sectionId;
    if (!sectionId) return;

    const safeId = sectionId.replace(/-/g, '_');
    window['openGiftPackagingModal_' + safeId] = () => window.openGiftPackagingModal(sectionId);
    window['closeGiftPackagingModal_' + safeId] = () => window.closeGiftPackagingModal(sectionId);
    window['handleGiftPhoneInput_' + safeId] = (input) => window.handleGiftPhoneInput(input, sectionId);
    window['submitGiftPackagingForm_' + safeId] = () => submitGiftPackagingForm(sectionId);

    // Setup Purpose pills selection
    const purposePills = modal.querySelectorAll('.gift-purpose-pill');
    purposePills.forEach((pill) => {
      pill.addEventListener('click', function () {
        purposePills.forEach((p) => p.classList.remove('is-selected'));
        this.classList.add('is-selected');
        const radio = this.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
      });
    });

    // Setup Style Cards selection
    const styleCards = modal.querySelectorAll('.gift-style-card');
    styleCards.forEach((card) => {
      card.addEventListener('click', function () {
        styleCards.forEach((c) => c.classList.remove('is-selected'));
        this.classList.add('is-selected');
        const radio = this.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
      });
    });

    // Close on backdrop click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        window.closeGiftPackagingModal(sectionId);
      }
    });
  }

  // Submit Handler
  async function submitGiftPackagingForm(sectionId) {
    const modal = document.getElementById('GiftPackagingModal-' + sectionId);
    if (!modal) return;

    const statusBox = document.getElementById('GiftStatusBox-' + sectionId);
    const statusText = statusBox ? statusBox.querySelector('.gift-status-text') : null;
    const submitBtn = document.getElementById('GiftSubmitBtn-' + sectionId);
    const productTitle = modal.dataset.productTitle || 'Sweet Box';
    const formId = modal.dataset.productFormId;
    const giftVariantId = modal.dataset.giftVariantId;
    const recipientPhone = modal.dataset.recipientNumber || '+917434088807';

    // Helper to show error
    function showError(msg) {
      if (statusBox && statusText) {
        statusBox.classList.remove('is-success');
        statusBox.classList.add('is-error');
        statusText.textContent = msg;
        statusBox.style.display = 'flex';
        statusBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        alert(msg);
      }
    }

    // Helper to hide status
    function hideStatus() {
      if (statusBox) {
        statusBox.style.display = 'none';
        statusBox.classList.remove('is-error', 'is-success');
      }
    }

    hideStatus();

    // Collect values
    const selectedPurposeEl = modal.querySelector('input[name="gift_purpose_' + sectionId + '"]:checked');
    const selectedPurpose = selectedPurposeEl ? selectedPurposeEl.value.trim() : 'Celebration Gifting';

    const selectedStyleEl = modal.querySelector('input[name="gift_style_' + sectionId + '"]:checked');
    const selectedStyle = selectedStyleEl ? selectedStyleEl.value.trim() : 'Royal Heritage Gift Box';

    const inputTo = modal.querySelector('#GiftInputTo-' + sectionId);
    const inputFrom = modal.querySelector('#GiftInputFrom-' + sectionId);
    const inputMsg = modal.querySelector('#GiftInputMessage-' + sectionId);
    const inputPhone = modal.querySelector('#GiftInputPhone-' + sectionId);
    const inputEmail = modal.querySelector('#GiftInputEmail-' + sectionId);

    const toName = inputTo ? inputTo.value.trim() : '';
    const fromName = inputFrom ? inputFrom.value.trim() : '';
    const giftMessage = inputMsg ? inputMsg.value.trim() : '';
    const rawPhone = inputPhone ? inputPhone.value.replace(/\D/g, '') : '';
    const email = inputEmail ? inputEmail.value.trim() : '';

    // Validations
    if (!toName) {
      showError("Please enter recipient's name (To).");
      inputTo?.focus();
      return;
    }

    if (!fromName) {
      showError("Please enter sender's name (From).");
      inputFrom?.focus();
      return;
    }

    if (!giftMessage) {
      showError('Please write a custom greeting message for the card.');
      inputMsg?.focus();
      return;
    }

    if (rawPhone.length !== 10 || !/^[6-9][0-9]{9}$/.test(rawPhone)) {
      showError('Please enter a valid 10-digit Indian mobile number.');
      inputPhone?.focus();
      return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError('Please enter a valid email address.');
      inputEmail?.focus();
      return;
    }

    // Get current selected main product variant & quantity
    let mainProductForm = null;
    if (formId) {
      mainProductForm = document.getElementById(formId);
    }
    if (!mainProductForm) {
      mainProductForm = document.querySelector(`form[id*="${sectionId}"]`) || document.querySelector('product-form form');
    }

    let mainVariantId = null;
    let quantity = 1;
    if (mainProductForm) {
      const variantInput = mainProductForm.querySelector('[name="id"]');
      if (variantInput) mainVariantId = variantInput.value;

      const qtyInput = mainProductForm.querySelector('[name="quantity"]');
      if (qtyInput) quantity = parseInt(qtyInput.value, 10) || 1;
    }

    if (!mainVariantId) {
      // Fallback from modal dataset or URL
      const currentUrl = new URL(window.location.href);
      mainVariantId = currentUrl.searchParams.get('variant') || modal.dataset.productId;
    }

    // Set Loading State
    const originalBtnHTML = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <span class="gift-spinner"></span>
        <span>Preparing Your Gift Package...</span>
      `;
    }

    // 1. Send Instantbroadcast WhatsApp / Lead API Payload
    try {
      let sendToNumber = recipientPhone.trim();
      if (!sendToNumber.startsWith('+')) {
        sendToNumber = '+' + sendToNumber;
      }

      const senderFromInfo = fromName + ' (Gift to: ' + toName + ')';
      const formattedPhone = '+91 ' + rawPhone;
      const fullMessageDetail = 'Packaging: ' + selectedStyle + ' | Message: "' + giftMessage + '"';
      const purposeDetail = selectedPurpose + ' | Gift Item: ' + productTitle;

      const apiPayload = {
        sendTo: sendToNumber,
        templetName: 'celebrate_form',
        exampleArr: [
          senderFromInfo,
          formattedPhone,
          email,
          fullMessageDetail,
          purposeDetail
        ],
        mediaUri: '',
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJ5Zm5pU3c5aldNWEx4ZVhlSEZpOWdGNjVwczZaU1ZJSCIsInJvbGUiOiJ1c2VyIiwiaWF0IjoxNzg4ODc0NDAxfQ.orOXsPIgPtqtCdG43PR8yr_pSxU5Wc8fjDds0Ev45Mc'
      };

      // Dispatch to API asynchronously (non-blocking if network fails)
      fetch('https://instantbroadcast.in/api/v1/send_templet', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJ5Zm5pU3c5aldNWEx4ZVhlSEZpOWdGNjVwczZaU1ZJSCIsInJvbGUiOiJ1c2VyIiwicGFzc3dvcmQiOiIkMmIkMTAkNGNmWVNyMy92NXpSUzhabmVWWFBwZWQ2Y2lyRXo4b2kwUTlCZk13TFk1US4zUVhUa3drN0ciLCJlbWFpbCI6InR1bGFzeWFtNUBnbWFpbC5jb20iLCJpYXQiOjE3ODg4NzM2Mjh9.vs_VpJW_9WGuxz-VtgGWchTKlrLTBJCaap_H0xWmgp4'
        },
        body: JSON.stringify(apiPayload)
      }).catch((e) => console.warn('Instantbroadcast API notice:', e));
    } catch (apiErr) {
      console.warn('API submission error:', apiErr);
    }

    // 2. Prepare Cart Payload for Shopify
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const itemsToAdd = [];

    // Main item with full customized properties
    itemsToAdd.push({
      id: parseInt(mainVariantId, 10) || mainVariantId,
      quantity: quantity,
      properties: {
        'Gift For': toName,
        'From': fromName,
        'Gift Purpose': selectedPurpose,
        'Packaging Style': selectedStyle,
        'Gift Message': giftMessage,
        '_is_gift_package': 'true'
      }
    });

    // Hidden Gift Packaging add-on product (if configured and distinct)
    if (giftVariantId && giftVariantId !== mainVariantId && giftVariantId !== '') {
      itemsToAdd.push({
        id: parseInt(giftVariantId, 10) || giftVariantId,
        quantity: 1,
        properties: {
          'For Item': productTitle,
          'Packaging Style': selectedStyle,
          'Recipient': toName,
          '_is_gift_addon': 'true'
        }
      });
    }

    const cartConfig = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: itemsToAdd,
        sections: cart ? cart.getSectionsToRender().map((s) => s.id) : [],
        sections_url: window.location.pathname
      })
    };

    const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    try {
      const response = await fetch(cartAddUrl, cartConfig);
      const data = await response.json();

      if (data.status && data.status >= 400) {
        throw new Error(data.description || data.message || 'Unable to add items to cart.');
      }

      // Success: Close modal
      window.closeGiftPackagingModal(sectionId);

      // Trigger cart drawer rendering or cart notification
      if (cart) {
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gift-packaging-form',
            cartData: data
          });
        }
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      }

    } catch (cartError) {
      console.error('Cart add error:', cartError);
      showError(cartError.message || 'Could not add gift package to cart. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnHTML;
      }
    }
  }

  // Escape key handler to close active modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.gift-modal-overlay.is-active');
      if (activeModal && activeModal.dataset.sectionId) {
        window.closeGiftPackagingModal(activeModal.dataset.sectionId);
      }
    }
  });

  // Initialize on DOMContentLoaded and shopify:section:load
  function initGiftModals() {
    const modals = document.querySelectorAll('.gift-modal-overlay');
    modals.forEach((modal) => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      initSectionHelpers(modal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftModals);
  } else {
    initGiftModals();
  }

  document.addEventListener('shopify:section:load', initGiftModals);
})();
